/* eslint-disable @typescript-eslint/no-unused-vars */
import {createRouter, createWebHistory, createWebHashHistory} from "vue-router";
import {routesMobile} from './mobile';
import {routesPc} from './pc';

const Adaptive = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|WebOS|Symbian|Windows Phone)/i;
const routes = (Adaptive.exec(navigator.userAgent)) ? routesMobile : routesPc;
const router = createRouter({
    history: createWebHistory(),
    // history: createWebHashHistory(),
    scrollBehavior() {
        return {
            top: 0
        };
    },
    routes,
});

export default router;
